import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.editor = this.element.querySelector("trix-editor")

    if (!this.editor) {
      console.error("No trix-editor found!")
      return
    }

    if (this.editor.editor) {
      this.setupChecklist()
    } else {
      this.editor.addEventListener("trix-initialize", () => {
        this.setupChecklist()
      })
    }

    this.editor.addEventListener("click", (e) => this.handleCheckboxClick(e))
    this.editor.addEventListener("keydown", (e) => this.handleKeyDown(e))
  }

  setupChecklist() {
    const toolbar = this.editor.toolbarElement
    if (!toolbar) return

    const blockTools = toolbar.querySelector(".trix-button-group--block-tools")
    if (!blockTools) return

    const btn = document.createElement("button")
    btn.type = "button"
    btn.className = "trix-button"
    btn.title = "Add Checklist Item"
    btn.tabIndex = -1
    btn.innerHTML = "☐"
    btn.style.cssText = `
      font-size: 16px;
      font-weight: bold;
      padding: 3px 6px;
      border: none;
      background: none;
      cursor: pointer;
    `

    btn.addEventListener("click", (e) => this.insertChecklistItem(e))
    blockTools.appendChild(btn)

    const style = document.createElement("style")
    style.innerHTML = `
      trix-editor::part(textarea) {
        cursor: text;
      }
      trix-editor .checkbox, trix-editor:has-text("☐"), trix-editor:has-text("☑") {
        cursor: pointer;
      }
    `
    document.head.appendChild(style)
  }

  insertChecklistItem(event) {
    event.preventDefault()

    const checklistText = "☐ "
    const range = this.editor.editor.getSelectedRange()

    this.editor.editor.setSelectedRange(range)
    this.editor.editor.insertString(checklistText)

    setTimeout(() => {
      const newRange = [range[0] + checklistText.length, range[0] + checklistText.length]
      this.editor.editor.setSelectedRange(newRange)
    }, 10)

    this.editor.focus()
  }

  handleCheckboxClick(event) {
    const selection = window.getSelection()
    if (!selection.rangeCount) return

    const range = selection.getRangeAt(0)
    const textNode = range.startContainer

    if (textNode.nodeType === Node.TEXT_NODE) {
      const text = textNode.textContent
      const clickPosition = range.startOffset

      const char = text.charAt(clickPosition)
      if (char === "☐" || char === "☑") {
        this.toggleCheckboxAtPosition(textNode, clickPosition)
        event.preventDefault()
      }
    }
  }

  handleKeyDown(event) {
    if (event.key === "Enter") {
      const selection = window.getSelection()
      if (!selection.rangeCount) return
      const range = selection.getRangeAt(0)
      const textNode = range.startContainer
      if (textNode.nodeType !== Node.TEXT_NODE) return

      const text = textNode.textContent
      const lineStart = this.findLineStart(text, range.startOffset)
      const char = text.charAt(lineStart)

      if (char === "☐" || char === "☑") {
        event.preventDefault()

        if (this.lastEnterTime && Date.now() - this.lastEnterTime < 400) {
          this.editor.editor.insertString("\n")
        } else {
          this.editor.editor.insertString("\n☐ ")
        }

        this.lastEnterTime = Date.now()
      }
    }
  }

  findLineStart(text, position) {
    let start = position
    while (start > 0 && text.charAt(start - 1) !== "\n") start--
    return start
  }

  toggleCheckboxAtPosition(textNode, position) {
    const text = textNode.textContent
    const char = text.charAt(position)

    const newChar = char === "☐" ? "☑" : "☐"
    const newText = text.substring(0, position) + newChar + text.substring(position + 1)
    const newTextNode = document.createTextNode(newText)

    textNode.replaceWith(newTextNode)
    const range = document.createRange()
    range.setStart(newTextNode, position + 1)
    range.collapse(true)

    const selection = document.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)

    this.editor.editor.recordUndoEntry("Toggle Checkbox")
    this.editor.dispatchEvent(new CustomEvent("trix-change", { bubbles: true }))
  }

  disconnect() {}
}
